import { Alert } from "@material-ui/lab"
import React from "react"

export default function AlertDiskon({ defaultDiskon }) {
  return (
    <>
      <Alert severity="info">Diskon awal adalah {defaultDiskon}%</Alert>
    </>
  )
}
